import React, { useState } from 'react';

const AlgorithmLogicTab = ({ vehicleTypes, priorityConfig, algorithmParams, onSaveConfig, onResetConfig }) => {
  const [localPriority, setLocalPriority] = useState(priorityConfig);
  const [localAlgorithmParams, setLocalAlgorithmParams] = useState(algorithmParams);
  const [localAllowedTypes, setLocalAllowedTypes] = useState(vehicleTypes);

  const handlePriorityChange = (index, direction) => {
    const newPriority = [...localPriority];
    [newPriority[index], newPriority[index + direction]] = [newPriority[index + direction], newPriority[index]];
    setLocalPriority(newPriority);
  };

  const handleToggleVehicleType = (type) => {
    setLocalAllowedTypes(prev => prev.includes(type) ? prev.filter(t => t !== type) : [...prev, type]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSaveConfig({ priority: localPriority, allowedTypes: localAllowedTypes, params: localAlgorithmParams });
  };

  return (
    <div style={{ background: 'white', borderRadius: '12px', padding: '25px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', paddingBottom: '15px', borderBottom: '2px solid #f3f4f6' }}>
        <h3 style={{ fontSize: '18px', fontWeight: 600, color: '#1f2937', margin: 0 }}>Algorithm Logic Configuration</h3>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button onClick={onResetConfig} style={{ padding: '10px 20px', background: '#f3f4f6', color: '#6b7280', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 500 }}>Reset</button>
          <button onClick={handleSubmit} style={{ padding: '10px 20px', background: '#667eea', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 500 }}>Save</button>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h4 style={{ fontSize: '16px', fontWeight: 600, color: '#1f2937', marginBottom: '15px' }}>Vehicle Priority</h4>
        <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '15px' }}>Set priority order for vehicle selection.</p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {localPriority.map((vehicle, index) => (
            <div key={vehicle} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '12px', background: '#f9fafb', borderRadius: '8px' }}>
              <span style={{ fontSize: '14px', fontWeight: 500, color: '#1f2937' }}>{index + 1}. {vehicle}</span>
              <div style={{ marginLeft: 'auto', display: 'flex', gap: '5px' }}>
                {index > 0 && <button onClick={() => handlePriorityChange(index, -1)} style={{ padding: '5px 10px', background: '#667eea', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>↑</button>}
                {index < localPriority.length - 1 && <button onClick={() => handlePriorityChange(index, 1)} style={{ padding: '5px 10px', background: '#667eea', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>↓</button>}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h4 style={{ fontSize: '16px', fontWeight: 600, color: '#1f2937', marginBottom: '15px' }}>Allowed Vehicle Types</h4>
        <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '15px' }}>Toggle to allow/disallow vehicle types for optimization.</p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '10px' }}>
          {['bike', 'car', 'truck', 'van'].map(type => (
            <div key={type} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '12px', background: '#f9fafb', borderRadius: '8px' }}>
              <label style={{ fontSize: '14px', color: '#1f2937', cursor: 'pointer', textTransform: 'capitalize' }}>{type}</label>
              <input type="checkbox" checked={localAllowedTypes.includes(type)} onChange={() => handleToggleVehicleType(type)} style={{ marginLeft: 'auto' }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AlgorithmLogicTab;
